<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-DESCRIPTION" :defaultOpen="defaultOpen">

    <!-- short description -->
    <div class="control">
      <div class="control-label">
        <label-name
          :labelKey="'PIM-PRODUCT-SHORT_DESCRIPTION' + labelSuffix"
        ></label-name>
      </div>
      <div class="control froalaRTE froalaPlain">
        <froala
          id="froala"
          ref="froala"
          :tag="'textarea'"
          :config="froalaConfig"
          v-model="product.shortDescription"
        ></froala>
      </div>
    </div>

    <!-- description -->
    <div class="control">
      <div class="control-label">
        <label-name
          :labelKey="'PIM-PRODUCT-DESCRIPTION' + labelSuffix"
        ></label-name>
      </div>
      <div class="control froalaRTE froalaPlain">
        <froala
          id="froala"
          ref="froala"
          :tag="'textarea'"
          :config="froalaConfig"
          v-model="product.descriptions.pim"
        ></froala>
      </div>
    </div>

    <ul class="otherValuesContainer" v-if="pharmacy == null">
      <li
        v-for="(val, key) in product.descriptions"
        class="otherValues"
        v-if="key != 'pim' && val != ''"
      >
        <span class="key">
          <lang :labelKey="'PIM-PRODUCT-DESC-' + key"></lang>: </span
        ><br /><span class="value" v-html="val"></span><br />
      </li>
    </ul>

  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionDescription",

  components: {
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    labelSuffix: { type: String, default: "" },
    froalaConfig: { type: Object, default: null },
    defaultOpen: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.otherValuesContainer {
  padding-left: 10px;
  margin: 0 0 40px 0;
  display: block;
  border: none;

  li.otherValues {
    background: #f0f1f2;
    border-radius: 3px;
    margin-bottom: 3px;
    padding: 2px 5px;
    white-space: normal;

    .key {
      display: inline-block;
      font-weight: 400;
      overflow: hidden;
      margin-right: 8px;
      font-size: 11px;
      text-transform: uppercase;
    }

    .value {
      font-size: 11px !important;
      width: 440px;

      p {
        padding-bottom: 10px;
      }
    }
  }
}

.froalaRTE {
  ::v-deep .fr-view {
    word-wrap: normal;
    white-space: normal;

    ul {
      display: block;
      border: none;
      margin-bottom: 15px;
      list-style-type: disc;
      list-style-position: outside;

      li {
        display: list-item;
      }
    }

    h1,
    h2,
    h3,
    h4 {
      all: revert;
    }
  }
}
</style>
